export const safeRedirect = (redirectUrl: string): string => {
    if (!redirectUrl.startsWith('/')) return '/'
    if (redirectUrl.includes('../') || redirectUrl.includes('..\\')) return '/'
    if (redirectUrl.startsWith('//') || redirectUrl.includes('://')) return '/'
    return redirectUrl
}

export const resolvePostAuthRedirect = (search: string, fallback: string): string => {
    const redirect = new URLSearchParams(search).get('redirect')
    return redirect ? safeRedirect(redirect) : fallback
}
